import React from 'react';

const fallbackUrl = 'http://a1.espncdn.com/espn3/images/watchespn/blackout-default-map.png';

const BlackoutMap = (props) => {
    const content = props.content;
    const fallbackImgStyle = {
        backgroundImage: `url(${fallbackUrl})`,
        height: '315px',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat'
    };
    const mapUrl = `http://a.espncdn.com/espn3/images/2010/blackout/${content.id}.jpg`;
    return (
        <div>
            <div style={fallbackImgStyle}>
                <img style={{ height: '315px' }} src={mapUrl} alt="Blackout map" />
            </div>
            <div>{content.name} - {content.date}</div>
            <div id="blackout-key">
                <div className="channel" id="espn"><img src="http://a.espncdn.com/espn3/images/watchespn/key_lin_e3_available.png" alt={`Available on ${content.source}`} />&nbsp;Available on <span id="linOnlyChan">{content.source}</span></div>
                <div className="channel" id="not-available"><img src="http://a.espncdn.com/espn3/images/watchespn/key_notavailable.png" alt="Not available" />&nbsp;Not available</div>
            </div>
        </div>
    );
};

BlackoutMap.propTypes = {
    content: React.PropTypes.object
};

export default BlackoutMap;



// WEBPACK FOOTER //
// ./app/modal/messaging/BlackoutMap.js